import React, { memo, useCallback, useMemo, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

import headerMenuStyles from './headerMenuStyles';

const DEFAULT_OPEN_HEADER_LINKS = 6;
const HeaderMenu = (props) => {
    const { headerLinks } = props;
    const classes = headerMenuStyles();
    const history = useHistory();

    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpen = useCallback((event) => {
        setAnchorEl(event.currentTarget);
    }, []);

    const handleClose = useCallback(() => {
        setAnchorEl(null);
    }, []);

    //Links displayed on header:
    const mainLinks = useMemo(() => headerLinks.slice(0, DEFAULT_OPEN_HEADER_LINKS), [headerLinks]);
    // Secondary links displayed on dropdown menu
    const secondaryLinks = useMemo(() => headerLinks.slice(DEFAULT_OPEN_HEADER_LINKS), [headerLinks]);

    const onClick = useCallback((path) => () => history.push(`/${path}`), [history]);

    return (
        <Grid container alignItems="center">
            {mainLinks.map((item) => {
                const { path, text } = item;
                return (
                    <NavLink
                        key={text}
                        className={classes.linkStyle}
                        to={`/${path}`}
                        exact={path === ''}
                        activeClassName={classes.activeRoute}
                    >
                        {text}
                    </NavLink>
                );
            })}
            {secondaryLinks.length > 0 && (
                <>
                    <Button
                        onClick={handleOpen}
                        className={`${classes.linkStyle} ${classes.menuPaddingOverride}`}
                    >
                        <Typography>More</Typography>
                        <ExpandMore />
                    </Button>
                    <Menu keepMounted onClose={handleClose} anchorEl={anchorEl} open={!!anchorEl}>
                        {secondaryLinks.map((item, index) => {
                            const { path, text } = item;
                            return (
                                <MenuItem key={text + index.toString()} onClick={onClick(path)}>
                                    <Link>{text}</Link>
                                </MenuItem>
                            );
                        })}
                    </Menu>
                </>
            )}
        </Grid>
    );
};
HeaderMenu.propTypes = {
    headerLinks: PropTypes.arrayOf(
        PropTypes.shape({
            path: PropTypes.string,
            text: PropTypes.string
        })
    ).isRequired
};

export default memo(HeaderMenu);
